<template>
  <div class="forfait__range">
    <div class="range__name">
      - {{ tranche.label }}
    </div>
    <div class="range__montant">
      <span class="symbol">Montant</span>
      <input
        v-model="updatedForfaitTransport.montant"
        type="text"
        class="value"
        @input="updateMode=true"
      > &nbsp;€
    </div>
    <div class="range__franco">
      <span class="symbol">
        Franco
      </span>
      <input
        v-model="updatedForfaitTransport.franco"
        type="text"
        class="value"
        @input="updateMode=true"
      > &nbsp;€
    </div>
    <a
      v-show="updateMode"
      class="forfait__update"
      @click="updateForfait()"
    >valider
    </a>
    <a
      class="forfait__delete"
      @click="deleteForfait(tranche.forfait.id)"
    >
      <span
        class="ui-icon ui-icon-trash"
      />
    </a>
  </div>
</template>
<script>
export default {
  props: {
    tranche: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      updateMode: false,
      updatedForfaitTransport: {
        id: this.tranche.forfait.id,
        montant: this.tranche.forfait.montant > 0 ? this.tranche.forfait.montant : 0,
        franco: this.tranche.forfait.franco > 0 ? this.tranche.forfait.franco : 0
      }
    }
  },
  methods: {
    deleteForfait(forfaitId) {
      this.$emit('deleteForfait', forfaitId)
    },
    updateForfait() {
      this.$emit('updateForfait', this.updatedForfaitTransport)
      this.updateMode = false
    }
  }
}
</script>
<style scoped>
  .forfait__range {
    display: flex;
    align-items: center;
    width: 70%;
    padding: 2px 2px 6px;
    margin-bottom: 6px;
  }
  .forfait__delete {
    margin: 0 10px;
    cursor: pointer;
  }

  .range__name {
    width: 35%;
    margin-right: 2rem;
    margin-left: 8px;
    font-weight: bold;
  }

  .range__montant {
    display: flex;
    align-items: center;
    padding: 0 4px;
    margin-right: 0.5rem;
  }

  .range__franco {
    display: flex;
    align-items: center;
    padding: 0 4px;
  }

  .symbol {
    margin-right: 0.5rem;
  }

  .value {
    padding: 0 0.4rem;
    background-color: #ffffff;
  }
</style>
